import React, { useState } from 'react';

import { useRouter } from 'next/router';
import Select from 'react-select';

import Style from '../Header.module.css';

import { citiesOptions } from '../../../../cities';
import { Button } from '../../../atoms';

import { durationOptions } from '../../../../constants';

function HeaderSearchWeb({ handleSearch }) {
  const router = useRouter();
  const params = router?.query;
  const convertStringToObjArr = (val) => {
    const arrOfLocation = val.split(',');
    const arr = [];

    for (let i = 0; i < arrOfLocation.length; i++) {
      arr.push({ label: arrOfLocation[i], value: arrOfLocation[i] });
    }

    return arr;
  };

  const [jobTitle, setJobTitle] = useState(params?.jobTitle ? params?.jobTitle : '');
  const [skill, setSkill] = useState(params?.skill ? params?.skill : '');
  const [location, setLocation] = useState(params?.location ? convertStringToObjArr(params?.location) : '');
  const [duration, setDuration] = useState(params?.duration ? durationOptions?.find((ele) => ele?.value == params?.duration) : '');

  const inputStyles = {
    control: (base) => ({
      ...base,
      color: '#3c4858',
      fontWeight: '400',
      border: 'none',
      boxShadow: 'none',
      display: 'flex',
      borderRadius: '5px',
      width: '100%',
      backgroundColor: '#FFFFFF',
      paddingLeft: '0',
      fontSize: '16px',
      lineHeight: '20px'
    }),
    menu: (base) => ({
      ...base,
      color: '#000000',
      fontSize: '16px',
      lineHeight: '20px',
      zIndex: '2000'
    })
  };

  const handleSearchClick = (event) => {
    event.preventDefault();
    handleSearch({
      jobTitle,
      skill,
      location,
      duration
    });
  };

  return (
    <div className='container'>
      <div className='padding16B'>
        <div className={`${Style.searchText} padding16T`}>Search for Jobs</div>
        <form className='row margin-0' onSubmit={(e) => handleSearchClick(e)}>
          <div className={`col-10 row margin-0 ${Style.searchBox}`}>
            <div className={`col-3 padding0 ${Style.searchInputbox} ${Style.radiusLeft} relative-position `}>
              <input
                className='y-center-Pos'
                id='jobTitle'
                name='jobTitle'
                onChange={(e) => {
                  setJobTitle(e.target.value);
                }}
                placeholder='Job Title'
                value={jobTitle}
              />
            </div>
            <div className={`col-3 padding0 ${Style.searchInputbox} relative-position`}>
              <input
                className='y-center-Pos'
                id='skill'
                name='skill'
                onChange={(e) => {
                  setSkill(e.target.value);
                }}
                placeholder='Skill'
                value={skill}
              />
            </div>
            <div className='col-3 padding0'>
              <Select
                className={`${Style.searchInputbox}`}
                id='location'
                isMulti={true}
                isOptionDisabled={() => location?.length >= 5}
                menuPosition='fixed'
                name='location'
                onChange={setLocation}
                options={citiesOptions}
                placeholder='Location'
                styles={inputStyles}
                value={location}
              />
            </div>
            <div className={`col-3 padding0 ${Style.searchInputbox} ${Style.radiusRight}  border-right-none`}>
              <Select
                className={`${Style.searchInputbox} border-right-none`}
                id='duration'
                isClearable={true}
                menuPosition='fixed'
                name='duration'
                onChange={setDuration}
                options={durationOptions}
                placeholder='Duration'
                styles={inputStyles}
                value={duration}
              />
            </div>
          </div>
          <div className={`col-2 ${Style.marginAuto} flexStyleEnd padding0`}>
            <Button className='general-style-2 wd-85 ' type='submit'>
              Search
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default HeaderSearchWeb;
